export default __webpack_public_path__ + "img/logo.ea3ee3d1.svg";